// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PricePicker: MarkdocTagRegistration = {
  tag: 'price-picker',
  component: 'PricePicker',
  selfClosing: true,
  attributes: {
    type: {
      type: String,
      default: 'default',
      matches: ['default', 'billing'],
    },
  },
};
